import type {
    PayerRequirementsDto,
    ServiceAddressItem,
    GovEnrollmentByState,
    AdditionalW9Item,
    AdditionalW9Dto,
    MedicareManager,
    MedicareManagementDto,
    IrsLetterDto,
    ProviderCredentialingPayoutAccountDto,
    FileRef,
    MedicaidEnrollmentDto,
    MedicaidOwner,
    MedicaidDelegated,
    PracticeRequirementsDto,
} from 'api/credentialing/types';

export type {
    PayerRequirementsDto,
    ServiceAddressItem,
    GovEnrollmentByState,
    AdditionalW9Item,
    AdditionalW9Dto,
    MedicareManager,
    MedicareManagementDto,
    IrsLetterDto,
    ProviderCredentialingPayoutAccountDto,
    FileRef,
    MedicaidEnrollmentDto,
    MedicaidOwner,
    MedicaidDelegated,
    PracticeRequirementsDto,
};

// 选 payer 后触发的条件步骤，顺序固定（原型 runPayerTriggeredSteps）：
// 104 NP → Gov → IRS letter → Service address → Medicare payout → Optum W-9 → Aetna Focus
export enum EPayerStep {
    NP_104 = 'np104',
    GOV_PROGRAM = 'govProgram',
    IRS_LETTER = 'irsLetter',
    SERVICE_ADDRESS = 'serviceAddress',
    MEDICARE_PAYOUT = 'medicarePayout',
    OPTUM_W9 = 'optumW9',
    AETNA_FOCUS = 'aetnaFocus',
}

// 触发链计算的输入：一条选中的 payer（名称 + 两字母州码 + payer 列表接口的 payerType，'Blue' = Blue plan）
export interface TSelectedPayer {
    payerName: string;
    state: string;
    payerType?: string | null;
}

// IRS letter / Medicare payout 两步除了看选了哪些 payer，还要看 provider 自身的状态（宿主异步取好传进来）。
// 不传时这两步一律不出现（只关心 Gov / Service address / W-9 / Aetna 的调用方无需改动）
export interface TPayerChainContext {
    group: boolean;
    // 按 EIN 开票：group 一律算；solo 要求 Verification 的 Tax ID 是 9 位且 ≠ SSN
    billsUnderTaxId: boolean;
    // 已有完整的 IRS letter（文件 + 名字）：solo / group 都不再问
    irsLetterOnFile: boolean;
    // 已有 payout 账户：solo 不再问；group 仍出现（预填 practice 账户，让每个 provider 看到钱打到哪）
    payoutOnFile: boolean;
    // 104 NP（10/26）：加州执照的 NP 才问；已答 Yes 不再问（答 No 时 Blue Shield of California 已不可选）
    needs104?: boolean;
    np104?: boolean | null;
}

// Service address 预填源：Basic information 的 contactAddress（只作用于同州的州块）
export interface TAddressPrefill {
    street?: string;
    city?: string;
    zip?: string;
    // 2-letter state code
    state?: string;
}
